import { Component } from '@angular/core';

export interface HomeItem {
  iconUrl: string;
  title: string;
  links: Array<HomeItemLinks>;
  viewAllUrl: string;
}

interface HomeItemLinks {
  label: string;
  url: string;
}

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent {
  public homeItems: Array<HomeItem> = [
    {
      iconUrl: 'assets/img/getting-started.svg',
      title: 'Getting Started',
      links: [
        {
          label: 'Finding Your Way Around Realist',
          url: '/getting-started/finding-your-way-around-realist'
        },
        {
          label: 'Understanding the Realist Search',
          url: '/getting-started/understanding-my-search'
        },
        {
          label: 'Understanding the Realist Map',
          url: '/getting-started/understanding-the-search-results-and-map'
        },
        {
          label: 'Setting your User Preferences',
          url: '/getting-started/setting-your-user-preferences'
        }
      ],
      viewAllUrl: '/getting-started/finding-your-way-around-realist'
    },
    {
      iconUrl: 'assets/img/features-guide.svg',
      title: 'Features Guide',
      links: [
        {
          label: 'Using My Search',
          url: '/feature-guide/using-my-search'
        },
        {
          label: 'Using the Realist Map',
          url: '/feature-guide/about-the-realist-map'
        },
        {
          label: 'Search Results Grid',
          url: '/feature-guide/search-results-grid'
        },
        {
          label: 'Ways to Work with Search Results',
          url: '/feature-guide/ways-to-work-with-search-results'
        },
        {
          label: 'Realist Reports',
          url: '/feature-guide/running-a-report'
        }
      ],
      viewAllUrl: '/feature-guide/selecting-county-region'
    },
    {
      iconUrl: 'assets/img/tutorials.svg',
      title: 'Tutorials',
      links: [
        {
          label: 'Introduction',
          url: '/tutorials/intro-to-realist'
        },
        {
          label: 'My Search',
          url: '/tutorials/using-search'
        },
        {
          label: 'Search Result Grid',
          url: '/tutorials/search-results-grid'
        },
        {
          label: 'Creating Mailing Addresses',
          url: '/'
        },
        {
          label: 'Running Report',
          url: '/tutorials/property-detail-report'
        }
      ],
      viewAllUrl: '/tutorials/intro-to-realist'
    }
  ];
}
